import React from "react";
import {
  TouchableOpacity,
  Text,
  InputAccessoryView,
  Platform,
  Keyboard,
  StyleSheet,
} from "react-native";

const KeyboardDoneButton = ({
  inputAccessoryViewID,
}: {
  inputAccessoryViewID: string;
}) => {
  if (Platform.OS !== "ios") {
    return null;
  }

  return (
    <InputAccessoryView nativeID={inputAccessoryViewID}>
      <TouchableOpacity
        style={styles.doneButton}
        onPress={() => Keyboard.dismiss()}
      >
        <Text style={styles.doneButtonText}>Done</Text>
      </TouchableOpacity>
    </InputAccessoryView>
  );
};

const styles = StyleSheet.create({
  doneButton: {
    backgroundColor: "#f8f8f8",
    borderTopWidth: 1,
    borderTopColor: "#dedede",
    padding: 12,
    alignItems: "flex-end",
  },
  doneButtonText: {
    color: "#007AFF",
    fontSize: 16,
  },
});

export default KeyboardDoneButton;
